import { render, staticRenderFns } from "./StudentTransferFormPage.vue?vue&type=template&id=a980cfc4&scoped=true"
import script from "./StudentTransferFormPage.vue?vue&type=script&lang=js"
export * from "./StudentTransferFormPage.vue?vue&type=script&lang=js"
import style0 from "./StudentTransferFormPage.vue?vue&type=style&index=0&id=a980cfc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a980cfc4",
  null
  
)

export default component.exports